import React from 'react';

interface PinIconProps {
  className?: string;
}

// Pushpin / thumbtack. Shown in place of the collapse chevron while the nav is
// temporarily slid out in Full-Slide mode, where the action is "pin this open"
// rather than "collapse this".
const PinIcon: React.FC<PinIconProps> = ({ className = 'h-6 w-6' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M9 2a1 1 0 0 0 0 2h.5v5.35l-2.7 2.03A3 3 0 0 0 5.6 13.8a1 1 0 0 0 .95 1.2H11v6a1 1 0 0 0 2 0v-6h4.45a1 1 0 0 0 .95-1.2 3 3 0 0 0-1.2-2.42l-2.7-2.03V4H15a1 1 0 0 0 0-2H9Z" />
    </svg>
  );
};

export default PinIcon;
